// Version : 0.0.1
// Author :AGALYA

const AuditingToolActionTypes = {
	/** ***************** GET AUDITING TOOL LIST START *********************** */
	GET_AUDITING_TOOL_LIST_START: 'get_auditing_tool_start',
	GET_AUDITING_TOOL_LIST_SUCCESS: 'get_auditing_tool_success',
	GET_AUDITING_TOOL_LIST_FAILURE: 'get_auditing_tool_failure',
	GET_AUDITING_TOOL_LIST_RESPONSE_RESET: 'get_auditing_tool_response_reset',
	GET_AUDITING_TOOL_LIST_RESPONSE_CHANGED: 'get_auditing_tool_response_changed',
	/** ***************** GET AUDITING TOOL LIST END *********************** */

	/** ***************** FETCH AUDITING TOOL LIST START *********************** */
	FETCH_AUDITING_TOOL_LIST_START: 'FETCH_AUDITING_TOOL_LIST_START',
	FETCH_AUDITING_TOOL_LIST_SUCCESS: 'FETCH_AUDITING_TOOL_LIST_SUCCESS',
	FETCH_AUDITING_TOOL_LIST_FAILURE: 'FETCH_AUDITING_TOOL_LIST_FAILURE',
	FETCH_AUDITING_TOOL_LIST_RESET: 'FETCH_AUDITING_TOOL_LIST_RESET',
	FETCH_AUDITING_TOOL_LIST_CHANGED: 'FETCH_AUDITING_TOOL_LIST_CHANGED',
	/** ***************** FETCH AUDITING TOOL LIST END *********************** */

	/** ***************** GET QUESTIONNAIRE START *********************** */
	GET_QUESTIONNAIRE_START: 'GET_QUESTIONNAIRE_START',
	GET_QUESTIONNAIRE_SUCCESS: 'GET_QUESTIONNAIRE_SUCCESS',
	GET_QUESTIONNAIRE_FAILURE: 'GET_QUESTIONNAIRE_FAILURE',
	GET_QUESTIONNAIRE_RESPONSE_RESET: 'GET_QUESTIONNAIRE_RESPONSE_RESET',
	GET_QUESTIONNAIRE_RESPONSE_CHANGED: 'GET_QUESTIONNAIRE_RESPONSE_CHANGED',
	/** ***************** GET QUESTIONNAIRE END *********************** */

	/** ***************** GET TRAINING PROPOSAL MEMBERS START *********************** */
	GET_TRAINING_PROPOSAL_MEMBERS_START: 'GET_TRAINING_PROPOSAL_MEMBERS_START',
	GET_TRAINING_PROPOSAL_MEMBERS_SUCCESS: 'GET_TRAINING_PROPOSAL_MEMBERS_SUCCESS',
	GET_TRAINING_PROPOSAL_MEMBERS_FAILURE: 'GET_TRAINING_PROPOSAL_MEMBERS_FAILURE',
	GET_TRAINING_PROPOSAL_MEMBERS_RESET: 'GET_TRAINING_PROPOSAL_MEMBERS_RESET',
	GET_TRAINING_PROPOSAL_MEMBERS_CHANGED: 'GET_TRAINING_PROPOSAL_MEMBERS_CHANGED',
	/** ***************** GET TRAINING PROPOSAL MEMBERS END *********************** */

	/** ***************** ADD TRAINING PROPOSAL START *********************** */
	ADD_TRAINING_PROPOSAL_START: 'ADD_TRAINING_PROPOSAL_START',
	ADD_TRAINING_PROPOSAL_SUCCESS: 'ADD_TRAINING_PROPOSAL_SUCCESS',
	ADD_TRAINING_PROPOSAL_FAILURE: 'ADD_TRAINING_PROPOSAL_FAILURE',
	ADD_TRAINING_PROPOSAL_RESET: 'ADD_TRAINING_PROPOSAL_RESET',
	ADD_TRAINING_PROPOSAL_CHANGED: 'ADD_TRAINING_PROPOSAL_CHANGED',
	/** ***************** ADD TRAINING PROPOSAL END *********************** */

	/** ***************** UPDATE TRAINING PROPOSAL START *********************** */
	UPDATE_TRAINING_PROPOSAL_START: 'UPDATE_TRAINING_PROPOSAL_START',
	UPDATE_TRAINING_PROPOSAL_SUCCESS: 'UPDATE_TRAINING_PROPOSAL_SUCCESS',
	UPDATE_TRAINING_PROPOSAL_FAILURE: 'UPDATE_TRAINING_PROPOSAL_FAILURE',
	UPDATE_TRAINING_PROPOSAL_RESET: 'UPDATE_TRAINING_PROPOSAL_RESET',
	UPDATE_TRAINING_PROPOSAL_CHANGED: 'UPDATE_TRAINING_PROPOSAL_CHANGED',
	/** ***************** UPDATE TRAINING PROPOSAL END *********************** */

	/** ***************** DELETE TRAINING PROPOSAL START *********************** */
	DELETE_TRAINING_PROPOSAL_START: 'DELETE_TRAINING_PROPOSAL_START',
	DELETE_TRAINING_PROPOSAL_SUCCESS: 'DELETE_TRAINING_PROPOSAL_SUCCESS',
	DELETE_TRAINING_PROPOSAL_FAILURE: 'DELETE_TRAINING_PROPOSAL_FAILURE',
	DELETE_TRAINING_PROPOSAL_RESET: 'DELETE_TRAINING_PROPOSAL_RESET',
	DELETE_TRAINING_PROPOSAL_CHANGED: 'DELETE_TRAINING_PROPOSAL_CHANGED',
	/** ***************** DELETE TRAINING PROPOSAL END *********************** */

	/** ***************** GET ALL SUPERVISER LIST START *********************** */
	GET_ALL_SUPERVISER_LIST_START: 'GET_ALL_SUPERVISER_LIST_START',
	GET_ALL_SUPERVISER_LIST_SUCCESS: 'GET_ALL_SUPERVISER_LIST_SUCCESS',
	GET_ALL_SUPERVISER_LIST_FAILURE: 'GET_ALL_SUPERVISER_LIST_FAILURE',
	GET_ALL_SUPERVISER_LIST_RESET: 'GET_ALL_SUPERVISER_LIST_RESET',
	GET_ALL_SUPERVISER_LIST_CHANGED: 'GET_ALL_SUPERVISER_LIST_CHANGED',
	/** ***************** GET ALL SUPERVISER LIST END *********************** */

	/** ***************** APPROVE TRAINING PROPOSAL START *********************** */
	APPROVE_TRAINING_PROPOSAL_START: 'APPROVE_TRAINING_PROPOSAL_START',
	APPROVE_TRAINING_PROPOSAL_SUCCESS: 'APPROVE_TRAINING_PROPOSAL_SUCCESS',
	APPROVE_TRAINING_PROPOSAL_FAILURE: 'APPROVE_TRAINING_PROPOSAL_FAILURE',
	APPROVE_TRAINING_PROPOSAL_RESET: 'APPROVE_TRAINING_PROPOSAL_RESET',
	APPROVE_TRAINING_PROPOSAL_CHANGED: 'APPROVE_TRAINING_PROPOSAL_CHANGED',
	/** ***************** APPROVE TRAINING PROPOSAL END *********************** */

	/** ***************** GET TRAINING PROPOSAL INDIVIDUAL START *********************** */
	GET_TRAINING_PROPOSAL_INDIVIDUAL_START: 'GET_TRAINING_PROPOSAL_INDIVIDUAL_START',
	GET_TRAINING_PROPOSAL_INDIVIDUAL_SUCCESS: 'GET_TRAINING_PROPOSAL_INDIVIDUAL_SUCCESS',
	GET_TRAINING_PROPOSAL_INDIVIDUAL_FAILURE: 'GET_TRAINING_PROPOSAL_INDIVIDUAL_FAILURE',
	GET_TRAINING_PROPOSAL_INDIVIDUAL_RESET: 'GET_TRAINING_PROPOSAL_INDIVIDUAL_RESET',
	GET_TRAINING_PROPOSAL_INDIVIDUAL_CHANGED: 'GET_TRAINING_PROPOSAL_INDIVIDUAL_CHANGED',
	/** ***************** GET TRAINING PROPOSAL INDIVIDUAL END *********************** */

	/** ***************** SAVE PHYSICAL DOCS START *********************** */
	SAVE_PHYSICAL_DOCS_START: 'SAVE_PHYSICAL_DOCS_START',
	SAVE_PHYSICAL_DOCS_SUCCESS: 'SAVE_PHYSICAL_DOCS_SUCCESS',
	SAVE_PHYSICAL_DOCS_FAILURE: 'SAVE_PHYSICAL_DOCS_FAILURE',
	SAVE_PHYSICAL_DOCS_RESET: 'SAVE_PHYSICAL_DOCS_RESET',
	SAVE_PHYSICAL_DOCS_CHANGED: 'SAVE_PHYSICAL_DOCS_CHANGED',
	/** ***************** SAVE PHYSICAL DOCS END *********************** */

	/** ***************** SAVE DIGITAL DOCS START *********************** */
	SAVE_DIGITAL_DOCS_START: 'SAVE_DIGITAL_DOCS_START',
	SAVE_DIGITAL_DOCS_SUCCESS: 'SAVE_DIGITAL_DOCS_SUCCESS',
	SAVE_DIGITAL_DOCS_FAILURE: 'SAVE_DIGITAL_DOCS_FAILURE',
	SAVE_DIGITAL_DOCS_RESET: 'SAVE_DIGITAL_DOCS_RESET',
	SAVE_DIGITAL_DOCS_CHANGED: 'SAVE_DIGITAL_DOCS_CHANGED',
	/** ***************** SAVE DIGITAL DOCS END *********************** */

	/** ***************** RE-AUDIT PROPOSAL START *********************** */
	RE_AUDIT_PROPOSAL_START: 'RE_AUDIT_PROPOSAL_START',
	RE_AUDIT_PROPOSAL_SUCCESS: 'RE_AUDIT_PROPOSAL_SUCCESS',
	RE_AUDIT_PROPOSAL_FAILURE: 'RE_AUDIT_PROPOSAL_FAILURE',
	RE_AUDIT_PROPOSAL_RESET: 'RE_AUDIT_PROPOSAL_RESET',
	RE_AUDIT_PROPOSAL_CHANGED: 'RE_AUDIT_PROPOSAL_CHANGED',
	/** ***************** RE-AUDIT PROPOSAL END *********************** */

	/** ***************** GET MEMBER AUDIT ANSWERS START *********************** */
	GET_MEMBER_AUDIT_ANSWERS_START: 'GET_MEMBER_AUDIT_ANSWERS_START',
	GET_MEMBER_AUDIT_ANSWERS_SUCCESS: 'GET_MEMBER_AUDIT_ANSWERS_SUCCESS',
	GET_MEMBER_AUDIT_ANSWERS_FAILURE: 'GET_MEMBER_AUDIT_ANSWERS_FAILURE',
	GET_MEMBER_AUDIT_ANSWERS_RESET: 'GET_MEMBER_AUDIT_ANSWERS_RESET',
	GET_MEMBER_AUDIT_ANSWERS_CHANGED: 'GET_MEMBER_AUDIT_ANSWERS_CHANGED',
	/** ***************** GET MEMBER AUDIT ANSWERS END *********************** */
};
export default AuditingToolActionTypes;
